import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAlertMarkersOption } from './aiAlertUtils';
import { useAiAlertEventData } from './useFetchAIAlerts';
import { selectedAiAlertIdSelector } from '@store/trends/aiAlerts/selectors';
import { TIME_AXIS, VALUE_AXIS } from '@components/metrics-panel-hz/utils/lineChartInputSchema';
import { findAxisIndex } from '@components/metrics-panel-hz/hooks/utils';
import { confirmAlertDrilldown } from '@components/alert-panel/AIAlert/componentUtils';
import { DATA_TAGS } from '../useData';

// modifies input series
export function formatAlertSeries(option, alerts = [], selectedAlertId) {

  // add alert series
  const alertSeries = getAlertMarkersOption({ alerts, selectedAlertId }, {
    xAxisIndex: findAxisIndex(option.xAxis, TIME_AXIS),
    yAxisIndex: findAxisIndex(option.yAxis, VALUE_AXIS),
  });

  return { series: [alertSeries] };
}

// there are two levels of enabled - hook enabled and feature toogle enabled
function useAIAlerts({ instance, metric, enabled = false, additionalTriggerDeps = [], drilldown = true, dataTag = DATA_TAGS.aiAlertEvents }: any) {
  const dispatch = useDispatch();
  const selectedAlertId = useSelector(selectedAiAlertIdSelector);
  const alerts = useAiAlertEventData({ metric, dataTag });

  useEffect(() => {
    if (instance && enabled) {
      // replace merge workflow resolved the race issues
      // TODO: remove timeout post additional testing
      setTimeout(() => {
        const option = instance.getOption();
        if(option) {
          const { series } = formatAlertSeries(option, alerts, selectedAlertId);
          instance.setOption({ series });
        }
      }, 100);
    }
  }, [instance, metric, enabled, JSON.stringify(alerts), selectedAlertId, ...additionalTriggerDeps]);

  const handleAlertClick = useCallback((params) => {
      if (params.componentType === 'markLine' && 'aiAlert' in params.data) {
        confirmAlertDrilldown(dispatch, params.data);
      }
  }, [metric]);

  useEffect(() => {
    if (instance && enabled && drilldown) {
      instance.on('click', handleAlertClick);
      return () => {
        instance.off('click', handleAlertClick);
      }
    }

  }, [instance, metric, enabled, drilldown]);
}

export default useAIAlerts;
